export default{

    //修改组件值
    alterStoreType(state,name){
        state.storeType = name;
    },

    //修改组件值
    alterComponentType(state,name){
        state.componentType = name;
    },

    //添加用户信息
    addProductId(state,id){
        state.productId = id;
    },

     //修改订单模块组件值
     alterStoreOrderType(state,name){
        state.storeOrderType = name;
    },

    //添加订单详情
    alterOrderId(state,id){
        state.orderId = id;
    },

    //修改订单详情组件
    alterOrderComponet(state,id){
        state.orderComponet = id;
    },

    //修改订单信息
    alterOrderRefundInfo(state,orderInfo){
        state.orderRefundInfo = orderInfo;
    },

}


// WEBPACK FOOTER //
// ./src/vuex/store/mutations.js